import './Select.module.css';
import ReactSelect from 'react-select';
import { ComponentProps, FC } from 'react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';

export interface SelectProps extends ComponentProps<typeof ReactSelect> {
  error?: boolean;
}

export const Select: FC<SelectProps> = ({
  placeholder = <FormattedMessage id="Select.Placeholder" />,
  error,
  ...props
}) => (
  <ReactSelect
    {...props}
    classNamePrefix="react-select"
    className={clsx('react-select', { error })}
    placeholder={placeholder}
  />
);
